// 2026-04-24: Debug page — hiện raw JSON response của /flashcard/progress
// Truy cập: /debug-flashcard (sau khi login NV)

import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

export default function DebugFlashcardPage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.flashcardProgress().then(setData).catch(setErr);
  }, []);

  if (err) return <pre className="p-4 text-red-600">{JSON.stringify(err, null, 2)}</pre>;
  if (!data) return <div className="p-4">Đang tải…</div>;

  return (
    <div className="p-4 bg-slate-50 min-h-screen">
      <h1 className="text-lg font-semibold mb-3">🐛 Debug Flashcard Progress</h1>
      <div className="bg-white border border-slate-200 rounded p-3 mb-4">
        <h2 className="font-semibold text-sm mb-2">upcoming_10d_daily</h2>
        <pre className="text-xs overflow-auto">{JSON.stringify(data.upcoming_10d_daily, null, 2)}</pre>
      </div>
      <div className="bg-white border border-slate-200 rounded p-3 mb-4">
        <h2 className="font-semibold text-sm mb-2">_debug_upcoming</h2>
        <pre className="text-xs overflow-auto">{JSON.stringify(data._debug_upcoming, null, 2)}</pre>
      </div>
      <div className="bg-white border border-slate-200 rounded p-3">
        <h2 className="font-semibold text-sm mb-2">Full response</h2>
        <pre className="text-xs overflow-auto max-h-96">{JSON.stringify(data, null, 2)}</pre>
      </div>
    </div>
  );
}
